import { FolderableCollectionLoadOnScrollServiceBase } from 'FoldersApp/services/folderable-collection-load-on-scroll-service-base.service';
import { SavedFundChartService } from 'NewAngular/features/components/saved-items/services/saved-fund-chart.service';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/features/components/saved-items/services/saved-fund-chart.service";
export class FundChartFolderableCollectionService extends FolderableCollectionLoadOnScrollServiceBase {
    get folderableCollection$() {
        if (this.dataParams === null)
            return null;
        const dataParams = formFlattenedObject(this.dataParams, Object.keys(this.dataParams));
        return this.savedChartService.getFolderableItems(dataParams);
    }
    constructor(savedChartService) {
        super();
        this.savedChartService = savedChartService;
        this.scrollableBodyId = 'fundChartsTable';
    }
}
FundChartFolderableCollectionService.ɵfac = function FundChartFolderableCollectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartFolderableCollectionService)(i0.ɵɵinject(i1.SavedFundChartService)); };
FundChartFolderableCollectionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: FundChartFolderableCollectionService, factory: FundChartFolderableCollectionService.ɵfac });
